module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-filter', {
    attrs: {
      "is-disabled": _vm.isDisabled
    },
    on: {
      "change": _vm.emitHandler
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.today')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.last_7')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.last_month')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "365"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.last_year')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.all
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.all_time')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-904ea892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/filters/PeriodFilter.vue
// module id = 1964
// module chunks = 0